export default {
    MATH_TEACHER: [
        {
            title: '悠数学介绍',
            desImg: require('@/assets/img/fdback/help_01desc_01.jpg'),
            sublist: [
                {
                    title: '一. 优质题库资源',
                    innerlist: [
                        {
                            elword: '收入各常用教辅及历年真题考题，为老师提供有针对性、个性化题库，提高教学效率。',
                            elimg: require('@/assets/img/fdback/help_01intro_01.jpg')
                        }
                    ]
                },
                {
                    title: '二. 多场景一键布置作业',
                    innerlist: [
                        {
                            elword: '悠数学根据教学的使用场景，推出了教辅作业、分层作业、智能推荐、知识点选题、同校老师作业、课后作业、试卷作业等功能，满足在不同教学时间段的作业需求，让布置作业省时省心。',
                            elimg: require('@/assets/img/fdback/help_01intro_02.png')
                        }
                    ]
                },
                {
                    title: '三. 作业自动批改',
                    innerlist: [
                        {
                            elword: '悠数学可以为您自动批改所有的作业题目，学生提交即可查看成绩，解放教师的劳动力。',
                            elimg: require('@/assets/img/fdback/help_01intro_03.jpg')
                        }
                    ]
                },
                {
                    title: '四. 作业统计分析',
                    innerlist: [
                        {
                            elword: '每次作业都会对学生成绩进行统计，错题、知识点掌握情况等多项数据，立体展现学情报告。从此，实现对孩子个性化指导不再是难题。',
                            elimg: require('@/assets/img/fdback/help_01intro_04.jpg')
                        }
                    ]
                },
                {
                    title: '五. 班级教学诊断分析',
                    innerlist: [
                        {
                            elword: '通过历史作业，统计班级整体教学诊断，班级的学习情况一目了然。每个月出具一份月度报告，详细了解当月班级学情，便于对症下药。',
                            elimg: require('@/assets/img/fdback/help_01intro_05.jpg')
                        }
                    ]
                },
                {
                    title: '六. 薄弱知识点针对练习',
                    innerlist: [
                        {
                            elword: '悠数学根据学生的历史作业，自动为您统计出薄弱知识点，并根据薄弱知识智能推荐巩固习题，复习不再困难。',
                            elimg: require('@/assets/img/fdback/help_01intro_06.jpg')
                        }
                    ]
                },
                {
                    title: '七. 私人精品题库',
                    innerlist: [
                        {
                            elword: '学生日常的错题会收入至错题本，教师也可以选择优质习题加入自己的私人好题本。错题本+好题本，轻松打造自己的私人题库。',
                            elimg: require('@/assets/img/fdback/help_01intro_07.jpg')
                        }
                    ]
                }
            ]
        },
        {
            title: '如何创建并管理班级?',
            sublist: [
                {
                    title: '如何创建班级？',
                    innerlist: [
                        {
                            elword: '在“班级·学情”页面中，点击右上角的创建班级，可以创建新的班级。',
                            elimg: require('@/assets/img/fdback/help_02class_02.png')
                        },
                        {
                            elword: '选择学生入学年份，输入班级名称后，点击确定创建班级。',
                            elimg: require('@/assets/img/fdback/help_02class_01.jpg')
                        }
                    ]
                },
                {
                    title: '如何让学生加入班级？',
                    innerlist: [
                        {
                            elword: '创建班级成功后，会自动生成一个班级码，你可以在我的班级中看到此班级码，将班级码告诉学生或使用QQ、微信分享给学生，学生输入此班级码就可以加入到你的班级了。',
                            elimg: require('@/assets/img/fdback/help_02class_03.png')
                        }
                    ]
                },
                {
                    title: '如何设置加入班级权限？',
                    innerlist: [
                        {
                            elword: '在“班级学生管理”页面中，点击“入班权限”，设置加入班级的权限',
                            elimg: require('@/assets/img/fdback/help_02class_04.png')
                        },
                        {
                            elword: '允许任何人加入：所有学生输入班级码即可加入<br>需要经过我同意：学生申请后，还需教师同意才可加入<br>禁止任何人加入：所有申请都自动拒绝，不可加入班级'
                        }
                    ]
                },
                {
                    title: '如何设置分组？',
                    innerlist: [
                        {
                            elword: '分组功能可以将班级学生分为多个组区别管理。在“我-我的班级”页面中，点击一个班级，进入班级详情，点击“+添加分组”。',
                            elimg: require('@/assets/img/fdback/help_02class_06.png')
                        },
                        {
                            elword: '勾选需要添加的学生，点击“下一步”，输入小组名称，并即可成功创建分组。',
                            elimg: require('@/assets/img/fdback/help_02class_07.jpg')
                        }
                    ]
                },
                {
                    title: '如何移除学生？',
                    innerlist: [
                        {
                            elword: '在“班级学生管理”页面中，点击 “移除学生”按钮，进入学生列表页，勾选要移除的学生，点击“移除”，即可将所选学生移除班级。',
                            elimg: require('@/assets/img/fdback/help_02class_08.png')
                        }
                    ]
                }
            ]
        },
        {
            title: '如何在线布置作业？',
            sublist: [
                {
                    title: '布置作业之“一键智能布置作业”',
                    innerlist: [
                        {
                            elword: '1.在“布置”页（即首页）点击“教辅作业、分层作业、同校作业、课后作业、课堂小测、试卷选题”功能，进入题目列表后，可直接点击底部的“布置在线作业”按钮，将当前列表中的题目一键布置给学生',
                            elimg: require('@/assets/img/fdback/help_03set_01.png')
                        }
                        // {
                        //     elword: '进入到题目列表页后，可点击底部的“一键布置”将页面中的所有题目作为一份作业布置给学生。',
                        //     elimg: require('@/assets/img/fdback/help_03set_02.jpg')
                        // },
                        // {
                        //     elword: '需要的题目，可以点击右下角加入作业篮子中，点击作业篮子即可开始布置。',
                        //     elimg: require('@/assets/img/fdback/help_03set_03.jpg')
                        // }
                    ]
                },
                {
                    title: '布置作业之“选题布置作业”',
                    innerlist: [
                        {
                            elword: '老师可在任意含有题目的界面中，点击“+加入作业”或“+”按钮，即可将题目加入到题目篮子中。',
                            elimg: require('@/assets/img/fdback/help_03set_z2.png')
                        },
                        {
                            elword: '点击页面右下角的作业篮子按钮，进入作业篮子查看已选的题目，点击作业篮子底部的“立即布置”按钮，即可将勾选的题目布置给学生。',
                            elimg: require('@/assets/img/fdback/help_03set_z1.png')
                        }
                        // {
                        //     elword: '在布置页面，可以设置作业标题，答题、截止时间，设置是否限时，选择需要布置的班级。设置完毕后点击“布置作业”按钮即可布置。',
                        //     elimg: require('@/assets/img/fdback/help_03set_06.jpg')
                        // }
                    ]
                },
                {
                    title: '设置作业的参数',
                    innerlist: [
                        {
                            elword: '在布置页面，可以设置作业名称，答题、截止时间，设置是否限时，作业的模式、选择好需要布置的班级，如含有解答题，勾选班级后则会出现是否使用解答题自动批改服务。设置完毕后点击“布置作业”按钮，作业就布置成功了，学生可登录悠数学学生端进行答题啦！',
                            elimg: require('@/assets/img/fdback/help_03set_04.png')
                        },
                        // {
                        //     elword: '点击 页面右下角的作业篮子按钮，进入作业篮子查看已选的题目，点击作业篮子底部的“立即布置”按钮，即可将勾选的题目布置给学生',
                        //     elimg: require('@/assets/img/fdback/help_03set_05.jpg')
                        // },
                        // {
                        //     elword: '在布置页面，可以设置作业标题，答题、截止时间，设置是否限时，选择需要布置的班级。设置完毕后点击“布置作业”按钮即可布置。',
                        //     elimg: require('@/assets/img/fdback/help_03set_06.jpg')
                        // }
                    ]
                }
            ]
        },
        {
            title: '作业模式和限时设置是什么？',
            sublist: [
                {
                    title: '作业模式',
                    innerlist: [
                        {
                            elword: '作业模式分成2种：'
                        },
                        {
                            elword: '1.作业模式：<br/>学生答题时，中途退出答题界面，计时停止，到了规定的限时时间后，仍可以继续答题。但教师可以在作业报告中看到超时完成的小标签，表示该学生未在限时时间内完成作业。'
                        },
                        {
                            elword: '2.考试模式：<br/>学生开始答题后，中途退出答题界面，仍继续计时，到规定的限时时间后，作业自动提交。'
                        },
                        {
                            elword: '限时设置：<br/>即设定学生完成作业的时间，超过时间后根据所选的作业模式会自动提交或继续作答，设定的时间必须小于作业开始时间与截止时间的中间总用时'
                        },
                        {
                            elword: '在布置作业页面，点击限时设置，选择限制时间和答题模式，即可布置限时作业。',
                            elimg: require('@/assets/img/fdback/5-1.png')
                        }
                    ]
                },
                {
                    title: '考试模式',
                    innerlist: [
                        {
                            // ht: '自由答题模式',
                            elword: '学生点击作业后，会看到限制时间和考试模式，点击开始答题后，会给予相关的提示。<br/>学生打开作业后，会看到：',
                            elimg: require('@/assets/img/fdback/5-z1.png')
                        },
                        {
                            // ht: '自由答题模式',
                            elword: '点击开始答题给予考前提示',
                            elimg: require('@/assets/img/fdback/5-z2.png')
                        }
                    ]
                },
                {
                    title: '作业模式',
                    innerlist: [
                        {
                            // ht: '自由答题模式',
                            elword: '学生开始答题后，会看到限制时间，需要在规定时间内作答。学生打开作业后，会看到：',
                            elimg: require('@/assets/img/fdback/5-z3.png')
                        },
                        {
                            // ht: '自由答题模式',
                            elword: '若学生没有在规定时限内完成答题，则会弹出提示，提醒学生未按时完成作业。',
                            elimg: require('@/assets/img/fdback/5-z4.jpg')
                        },
                        {
                            // ht: '自由答题模式',
                            elword: '教师可以在作业详情中查看未在限时内完成作业的学生。',
                            elimg: require('@/assets/img/fdback/5-z5.jpg')
                        }
                    ]
                }
            ]
        },
        // {
        //     title: '如何使用解答题免批改功能？',
        //     subUrl:'/correctFaq',
        //     sublist: []
        // },
        {
            title: '如何手动批改解答题？',
            sublist: [
                {
                    title: '如何手动批改解答题？',
                    innerlist: [
                        {
                            elword: '在布置作业时，未开启“解答题自动批改”服务或部分学生无法进行解答题免批改，则此次作业中的解答题均需要老师您自己手动的批改'
                        },
                        {
                            elword: '当学生提交作业后，有需要手动批改的题目时，进入作业详情页，页面底部会出现“批改作业”按钮，点击后开始批改作业。',
                            elimg: require('@/assets/img/fdback/help_06_01.jpg')
                        },
                        {
                            elword: '选择要批改的题目，进入批改页面',
                            elimg: require('@/assets/img/fdback/help_06_02.jpg')
                        },
                        {
                            elword: '您可以在此查看当前该题目需要批改的学生的答案，在图片上进行手写批注并选择批改结果。',
                            elimg: require('@/assets/img/fdback/help_06_032.jpg')
                        },
                        // {
                        //     elword: '点击底部的图片批注可以进行图片批注，别忘了在批注后保存哦。',
                        //     elimg: require('@/assets/img/fdback/help_06_04.jpg')
                        // },
                        {
                            elword: '您还可以添加语音批注，添加后学生可以直接在自己的作业中收听。',
                            elimg: require('@/assets/img/fdback/help_06_05s.jpg')
                        }
                        // {
                        //     elword: '如果学生上传了图片，点击图片可以进行图片批注，别忘了在批注后保存哦。',
                        //     elimg: require('@/assets/img/fdback/help_06_04.jpg')
                        // },
                        // {
                        //     elword: '您还可以添加语音批注，添加并下发作业后学生可以直接在自己的作业中收听。',
                        //     elimg: require('@/assets/img/fdback/help_06correct_04.jpg')
                        // },
                        // {
                        //     elword: '作业批改完成后，在作业详情可点击“下发作业”按钮下发。',
                        //     elimg: require('@/assets/img/fdback/help_06correct_05.jpg')
                        // }
                    ]
                }
            ]
        },
        {
            title: '同校老师如何共享作业题目？',
            sublist: [
                {
                    title: '将作业中的题目共享给同校老师查看',
                    innerlist: [
                        {
                            elword: '1.首先老师必须要在“我-设置-学校”上选择自己当前的学校信息。<br/>2.在布置页的底部勾选“允许向同校老师共享作业题目内容”，作业布置成功后，同校老师即可查看到您共享的这份作业了。',
                            elimg: require('@/assets/img/fdback/7-z1.png')
                        }
                    ]
                },
                {
                    title: '如何查看同校老师共享的作业？',
                    innerlist: [
                        {
                            elword: '在首页，自主选题区域，点击“同校作业”按钮，即可查看到该校老师共享的作业，点击作业后，即可布置给自己班级的学生'
                        },
                        {
                            elimg: require('@/assets/img/fdback/help_07paper_01.png')
                        },
                        {
                            elword: '注意：仅支持查看近30天的共享作业'
                        }
                    ]
                }
            ]
        },
        {
            title: '如何查看已布置的作业完成情况？',
            sublist: [
                {
                    title: '请老师先了解下作业的状态',
                    innerlist: [
                        {
                            elword: '按照作业流程，可分为以下4个状态：<br>待分发：作业已布置，尚未分发，学生暂时无法查看<br>作业中：作业已分发，学生正在答题中<br>已截止：作业已到截至时间，学生无法再进行答题<br>待批改：有需要老师手动批改的题目'
                        }
                    ]
                },
                {
                    title: '如何查看作业？',
                    innerlist: [
                        {
                            elword: '点击“作业”tab，可以查看所有布置过的作业，也可点击右上角的筛选进行快速查询。',
                            elimg: require('@/assets/img/fdback/help_05state_01.png')
                        },
                        {
                            elimg: require('@/assets/img/fdback/help_05_02.png')
                        },
                        {
                            elword: '点击一份作业，可以查看作业整体情况，包括正确率分布、提交人数、作业中题目的平均正确率等信息，作业数据实时统计，请及时下拉刷新页面哦。',
                            elimg: require('@/assets/img/fdback/help_05_03.png')
                        },
                        // {
                        //     elword: '作业被批改完成后，会自动生成作业报告，可以查看作业整体情况，包括正确率分布、用时等信息',
                        //     elimg: require('@/assets/img/fdback/help_05_04.jpg')
                        // }
                    ]
                },
                {
                    title: '如何查看单个学生作业？',
                    innerlist: [
                        {
                            elword: '在学生列表中点击需要查看的学生，即可查看单个学生作业。',
                            elimg: require('@/assets/img/fdback/help_05_05.jpg')
                        }
                    ]
                }
            ]
        },
        {
            title: '如何将作业成绩导出到Excel？',
            sublist: [
                {
                    title: '导出多份作业记录到Excel',
                    innerlist: [
                        {
                            elword: '在“作业”tab中，点击右上角的更多按钮，点击导出作业记录到Excel，选择要导出的班级及时间段后，就可将作业记录导出了。'
                        },
                        {
                            elword: '导出成功后，支持直接将文件发送到QQ或微信',
                            elimg: require('@/assets/img/fdback/help_12excel_01.png')
                        }
                    ]
                },
                {
                    title: '导出单份作业中的学生成绩到Excel',
                    innerlist: [
                        {
                            elword: '在作业列表中，点击一份作业进入“作业报告”页面，切换到“作业信息”tab下,点击“导出作业成绩到Excel”即可将所有已提交作业且已批改完成的学生成绩导出。'
                        },
                        {
                            elword: '导出成功后，支持直接将文件发送到QQ或微信',
                            elimg: require('@/assets/img/fdback/help_12excel_02.png')
                        }
                    ]
                }
            ]
        },
        {
            title: '什么是错题本、好题本?',
            sublist: [
                {
                    title: '什么是错题本？',
                    innerlist: [
                        {
                            elword: '班级作业中平均正确率低于60%的题目会自动加入错题本，您可以在“学情-班级错题本”中查看并管理每个班级的错题本。',
                            elimg: require('@/assets/img/fdback/help_08book_02.png')
                        }
                    ]
                },
                {
                    title: '什么是好题本？',
                    innerlist: [
                        {
                            elword: '好题本是您收藏的好题题集，类似于“收藏夹”的功能。您可以在题目详情中将题目加入好题本。',
                            elimg: require('@/assets/img/fdback/help_08book_01.jpg')
                        },
                        {
                            elword: '您可以在“我的--好题本”中查看并管理好题本',
                            elimg: require('@/assets/img/fdback/help_08book_03.png')
                        }
                    ]
                }
                // {
                //     title: '如何通过错题本、好题本布置作业？',
                //     innerlist: [
                //         {
                //             elword: '在“资源”页，点击顶部的“好题本”或“错题本”，进入后在题目列表页点击“加入作业”后，即可将题目加入作业篮子中。',
                //             elimg: require('@/assets/img/fdback/help_08book_02.jpg')
                //         },
                //         {
                //             elimg: require('@/assets/img/fdback/help_08book_03.jpg')
                //         }
                //     ]
                // }
            ]
        },
        {
            title: '如何查看班级学情?',
            sublist: [
                {
                    title: '什么是班级学情？',
                    innerlist: [
                        {
                            elword: '班级学情是悠数学通过作业成绩，统计出的班级整体学习情况。在“班级·作业-查看班级学情数据分析”页面中，可以查看班级整体情况。',
                            elimg: require('@/assets/img/fdback/help_09study_01.png')
                        },
                        {
                            elword: '近期班级平均正确率是您的班级近3个月以来，每周平均正确率的变化曲线，布置的作业越多，统计越精确。',
                            elimg: require('@/assets/img/fdback/help_09study_02.png')
                        },
                        {
                            elword: '章节掌握情况是根据以往作业的完成情况，分析出的各章节掌握情况。',
                            elimg: require('@/assets/img/fdback/help_09study_03.png')
                        },
                        {
                            elword: '您可以点击其中的章节，系统根据掌握情况自动为您推荐巩固习题，您可以选择布置给学生作为练习作业。',
                            elimg: require('@/assets/img/fdback/help_09study_04.png')
                        },
                        {
                            elword: '除此之外，还可以查看班级的成绩排名、进步排名、退步排名。',
                            elimg: require('@/assets/img/fdback/help_09study_05.png')
                        }
                    ]
                },
                {
                    title: '什么是月度报告？',
                    innerlist: [
                        {
                            elword: '班级创建后，如果当月有布置过作业，则会在每月的1号为您统计一份上个月的月度报告，统计上个月的班级成绩。<br>可以在“我--班级学情分析”页面中查看学情报告。',
                            elimg: require('@/assets/img/fdback/help_09study_06.png')
                        },
                        {
                            elword: '月度报告为您统计了当月所有作业的正确率变化，班级学生正确率分布，班级学生成绩、进步、退步排名及各章节的掌握情况，您可以清晰的看到该月班级的作业表现。'
                        }
                    ]
                }
            ]
        },
        {
            title: '如何转让班级？',
            sublist: [
                {
                    title: '什么是转让班级？',
                    innerlist: [
                        {
                            elword: '新学期到了，在学期更替之际，也可能存在班级教师变动的情况。<br>转让班级功能可以方便教师在班级变动时，将自己的班级转让给新老师，从而更快完成交接任务的工作。<br>注：仅校级用户可转让班级。'
                        }
                    ]
                },
                {
                    title: '如何转让班级？',
                    innerlist: [
                        {
                            elword: '在“学情-学生管理”页面中，点击右上角的设置，再点击“转让班级”',
                            elimg: require('@/assets/img/fdback/help_10class_01.png')
                        },
                        {
                            elword: '在这个页面中，可以查看所有本校的老师，可以通过搜索来快速找到指定的老师。点击“转让班级”，即可将班级转让给新老师。',
                            elimg: require('@/assets/img/fdback/help_10class_02.jpg')
                        }
                    ]
                },
                {
                    title: '班级转让后,对老师有什么影响？',
                    innerlist: [
                        {
                            elword: '班级转让是一个不可逆的操作，转让后，班级会交由新老师管理，请与新老师沟通后再进行操作。'
                        },
                        {
                            elword: '班级转让后，对于原班级老师：<br>1、该班级作业将从作业管理中消失，不可再布置作业给该班级。<br>2、该班级将从班级列表中消失，不可查看或管理。'
                        },
                        {
                            elword: '对于新老师：<br>1、该班级将出现在新老师班级列表中，可查看和管理。<br>2、该班级的学生分组、作业历史记录将保留。<br>3、该班级待处理的作业将交由新老师负责，新老师可以布置作业给该班级学生。'
                        }
                    ]
                }
            ]
        },
        {
            title: '系统将题目批改错误怎么办？',
            sublist: [
                {
                    title: '对系统批改出错的题目进行申诉',
                    innerlist: [
                        {
                            elword: '当发现系统将题目批改错误后，可点击学生作业中的题号，进入题目详情页后，点击页面中的“批改错误，申诉重批”按钮，填写申诉的原因后，该题会自动进入批改系统，由人工对系统进行矫正并再次批改。'
                        },
                        {
                            elword: '注意：仅支持系统批改的填空题、解答题',
                            elimg: require('@/assets/img/fdback/help_11ques_01.png')
                        },
                        {
                            elimg: require('@/assets/img/fdback/help_11ques_02.png')
                        }
                    ]
                }
            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./src/mock/fdbackintro.js